// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__3b6tj","isMainTile":"Actions_isMainTile__mbTAg","home":"Actions_home__iHb1G"};